export default __webpack_public_path__ + "static/burredwave-70a34f5236a89e8e4b0f7fba25b9d9d2.png";